import enUS from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'

const dateLocales: { [locale: string]: Locale } = {
    es,
    'en-US': enUS
}
export default dateLocales
